import api from './api';

export const reachService = {
  getCities:         ()             => api.get('/reach/cities'),
  getAllCities:       ()             => api.get('/reach/cities/all'),
  createCity:        (data)         => api.post('/reach/cities', data),
  updateCity:        (id, data)     => api.put(`/reach/cities/${id}`, data),
  deleteCity:        (id)           => api.delete(`/reach/cities/${id}`),
  reorderCities:     (order)        => api.put('/reach/cities/reorder', { order }),
  createTransport:   (cityId, data) => api.post(`/reach/cities/${cityId}/transports`, data),
  updateTransport:   (id, data)     => api.put(`/reach/transports/${id}`, data),
  deleteTransport:   (id)           => api.delete(`/reach/transports/${id}`),
  reorderTransports: (order)        => api.put('/reach/transports/reorder', { order }),
};
